import {Component, OnDestroy} from '@angular/core';
import {MarcoService} from '@core/services/marco.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-marco-pages',
  templateUrl: './marco-pages.component.html',
  styleUrls: ['./marco-pages.component.scss'],
  providers: [MarcoService],
})
export class MarcoPagesComponent implements OnDestroy {
  private subscription: Subscription;
  public titulo: String = '';
  public currentDate: Date = new Date();

  constructor(public marcoService: MarcoService) {
    this.subscription = this.marcoService
      .onTitulo()
      .subscribe(titulo => (this.titulo = titulo));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
